import { useEffect, useState } from "react";
import { fetchSalaries } from "../Api/ViewSalary";
import { Container, Table } from "react-bootstrap";

//import "../Styling/ViewSalary.css";
import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext";
const ViewSalary = () => {
  const [salaries, setSalaries] = useState([]);
const {user}=useAuth();
  useEffect(() => {
    const loadSalaries = async () => {
      try {
        const data = await fetchSalaries(user?.organisationId);
        setSalaries(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Salary Data`);
      }
    };

    loadSalaries();
  }, []);

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <span className="list-title">View Salary Data</span>

            {salaries.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Salary ID</th>
                        <th>Resource ID</th>
                        <th>Resource Name</th>
                        <th>Valid From</th>
                        <th>Valid To</th>
                        <th>Gross</th>
                        <th>PF</th>
                        <th>ESIC</th>
                        <th>HRA</th>
                        <th>TA</th>
                        <th>MA</th>
                        <th>Basic In Hand</th>
                        <th>Salary Status</th>

                      </tr>
                    </thead>
                    <tbody>
                      {salaries.map((salary, index) => (
                      <tr key={index}>
  <td>{index + 1}</td>
  <td>{salary.salary.salaryId}</td>
  <td>{salary.salary.resourceId}</td>
  <td>{salary.resource}</td>

  <td>{moment(salary.salary.validFrom).format("DD-MM-YYYY")}</td>
  <td>{moment(salary.salary.validTo).format("DD-MM-YYYY")}</td>

  <td>
    {salary.salary.basicPlusDa +
      salary.salary.hra +
      salary.salary.ma +
      salary.salary.ta +
      salary.salary.other -
      salary.salary.pfEmployee -
      salary.salary.esicEmployee}
  </td>

  <td>{salary.salary.pfEmployee ?? "N/A"}</td>
  <td>{salary.salary.esicEmployee ?? "N/A"}</td>
  <td>{salary.salary.hra ?? "N/A"}</td>
  <td>{salary.salary.ta ?? "N/A"}</td>
  <td>{salary.salary.ma ?? "N/A"}</td>
  <td>{salary.salary.basicPlusDa}</td>
  <td>{salary.activeStatus ? "Active" : "Inactive"}</td>
</tr>

                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No salary data found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewSalary;